<template>
    <div>
        <!-- <no-data v-show="noDataShow" title='暂无阀门' ></no-data> -->
        
        <div class="pageTop">
            <div class='left'>                
                <p v-show="!leftBtn" class='title'>{{baseName}}</p>
                <div v-show="leftBtn">
                    <van-checkbox @change='bothChecked' v-model="checkedAll"  shape="square" style="display: inline-flex;font-size: 14px;vertical-align: middle;">全选</van-checkbox>
                    &nbsp;
                    <van-button color='#1588d0' type="info" @click='nowOpen'  size="small">立即开启</van-button>
                    &nbsp;
                    <van-button color='#1588d0' type="info" @click='timingOpen' size="small">预约开启</van-button>
                </div>
            </div>
            <div class='right'>
                <van-button color='#1588d0' type="info" :disabled='login==0?true:false'  @click='multiple' size="small">多选阀门</van-button>
                <van-icon name="apps-o" color='#0076bf' size='22' @click="rListShow" style="vertical-align: middle;margin-left:15px"/>
                
            </div>
        </div>
        <div  ref='pageMain'  style="overflow:auto">
            <van-checkbox-group v-model="checkerArr" ref="checkboxGroup">
            <van-grid  :column-num="3">
            <van-grid-item v-for="(item,index) in valveList" :key="index">
                <div class="valveBox">
                     <van-checkbox :name="item.pc_id" v-show="checkIsShow"  ></van-checkbox>
                    <!-- <input type="checkbox" class='valveCheck' style="float:right" v-show="checkIsShow" v-model="checkerArr"  name="valve" :value="item.pc_id"> -->
                    <p class='valveTitle' >{{item.name}}</p>
                    <img class="leftImg" v-if="item.opened == 0 ? true:false " src="@/assets/close.png"  alt="" >
                    <img class="leftImg" v-else src="@/assets/open.png"  alt="" >
                    <div class='rightIcon'>
                        <ul>
                            <li><img src="@/assets/battery.png"  alt=""><span >{{item.rtu_power}}</span></li>
                            <li><img src="@/assets/signal.png"   alt=""><span >{{item.rtu_signal}}</span></li>
                            <li><img src="@/assets/pressure.png" alt=""><span >{{item.pressure}}</span></li>
                        </ul>
                    </div>
                    <p class="timeBox" style="margin-top:15px"><img src="@/assets/time.png"  alt="" ><span >{{TimeArr[index]}}</span></p>
                    <van-button v-if='item.opened == 0 ? true : false' class='openBtn' type="info" size="small" :disabled='item.status == 0?false:true' :loading='item.status == 0?false:true'  @click='valveOperate(item,index)'>开启</van-button>
                    <van-button v-else style="width:90%;margin-top:10px" type="danger" size="small" :disabled='item.status == 0?false:true' :loading='item.status == 0?false:true' @click='valveOperate(item,index)'>关闭</van-button>
                    <!-- <x-button v-if='item.opened == 0 ? true : false' class='openBtn'  mini>开启</x-button>
                    <x-button v-else type='warn' style="width:90%;margin-top:10px"  mini>关闭</x-button> -->
                </div>
            </van-grid-item>
            </van-grid>
            </van-checkbox-group>
            <van-divider  :style="{padding: '0 16px' }">
                没有更多啦
            </van-divider>


            <van-popup  position="bottom" v-model="timingIsShow"  closeable  :style="{ height: '40%' }" get-container="body">
                <div class='van-action-sheet__header van-hairline--bottom'>预约开启</div>
                <van-cell-group title="开启阀门">
                    <van-notice-bar  background="#fff" :scrollable='false' wrapable>
                        {{checkerNameArr}}
                    </van-notice-bar>                
                </van-cell-group>
                <van-cell-group title="开启时间">
                    <van-cell title="选择时间" @click="timePop = true"  is-link>
                        <div slot='default'>{{nowTime}}</div>
                    </van-cell>                    
                </van-cell-group>
                <van-cell-group title="开启时长">
                    <van-cell title="选择时长" @click="durationPop = true"  is-link>
                        <div slot='default'>{{durationValue}}</div>
                    </van-cell>
                    <van-cell title="自定义时长(小时)" v-show='durationShow'>
                        <div slot='default'>
                            <van-field v-model="durationNum" type='number' placeholder="请输入时长" />
                        </div>
                    </van-cell>

                </van-cell-group>
                <van-button type="info" block size="normal" :loading='timingState' :disabled='timingState' style="width:90%;margin:15px auto " @click="timingStart">立即预约</van-button>
            </van-popup>
        </div>

        <van-popup  position="bottom" v-model="timePop"  :style="{ height: '40%' }" get-container="body">
            <van-datetime-picker @cancel='timePop = false' @change='setChangeTime' :min-date="minDate"  @confirm="setNewTime"    type="datetime" />
        </van-popup>

        <van-popup  position="bottom" v-model="durationPop"  :style="{ height: '40%' }" get-container="body">
            <van-picker  show-toolbar   :columns="timeOptions"  @cancel="durationPop = false"  @confirm="setDuration" />
            
        </van-popup>



    </div>
</template>

<script>
var timingCount
import {getNodeValvePoint} from '@/request/data'
import noData from '@/components/noData.vue'
export default {    
    props:{
        uuid:{
            type:[String,Number],
            required: true
        },
        baseName:{
            type:String,
        },
        login:{
            type:[String,Number],
        },
        nodeType:{
            type:[String,Number],
        }
    },
    components:{
        noData
    },
    data() {
        return {
            clientHeight:'',
            leftBtn:false,
            checkIsShow:false,
            timingIsShow:false,
            checkedAll:false,
            timePop:false,
            minDate:'',
            timingTime:'',            
            nowTime:'',
            checkerArr:[],
            bothCheckBtn:[],
            checkerNameArr:[],
            valveList:[],
            TimeArr:[],
            timeOptionsVlue:'',
            timeOptions:['不限时长','0.5小时','1小时','1.5小时','2小时','自定义'],
            durationValue:'',
            durationNum:'',
            durationPop:false,
            durationShow:false,
            isShowCustomTime:false,           
            noDataShow:true,
            setInArr:[],
            secondArr:[],
            timingState:false,
            timingCountDown:''
        }
    },
    mounted() {
        let date=new Date()
        this.minDate = new Date(date.getFullYear(),date.getMonth(),date.getDate(),date.getHours(),date.getMinutes())
        this.clientHeight =   `${document.documentElement.clientHeight}`
        window.onresize = function temp() {
            this.clientHeight = `${document.documentElement.clientHeight}`;
        };       
        this.getValveList()
    },
    watch: {
        clientHeight: function () {
            this.changeFixed(this.clientHeight)
        },
        "$store.state.websocket.msg":{
            handler(newVal,oldVal){
                console.log('阀门页面监听到服务器回应:'+ 'newVal:' + newVal + ',oldVal' + oldVal)
                this.valveOperateOnMessage()
                this.multipleSelectionMessage()
            },
            immidiate:true,
            deep:true,
        }
    },
    methods: {
        getValveList(){
            let data ={}
            data.uuid = this.uuid
            // data.token = this.token
            getNodeValvePoint(data).then(res=>{                
                this.valveList = []
                if (res.data.code ==0 && res.data.hasOwnProperty('data')) {
                    this.noDataShow = false
                    this.valveList = res.data.data
                    this.computeDate()
                }else{
                    this.noDataShow = true
                    // this.$toast.fail({message:'基地暂无阀门',forbidClick:true,duration:1000});
		        }
            })
        },
        computeDate(){//循环时间
            if(this.valveList){
                if(this.valveList.length){
                    let setTime
                    window.clearInterval(setTime)
                    let _that = this
                    setTime =  setInterval(() => {
                        this.TimeArr = []
                        for (let i = 0; i < _that.valveList.length; i++) {
                            let nowTime = (new Date()).getTime();//获取现在时间戳
                            _that.computeTime(_that.valveList[i].start_time,nowTime)        
                        }
                    }, 1000);
                }
            } 
        },
        computeTime(starTime,nowTime){//计算时间差
            let timeReduce
            let timeStar = new Date(starTime).getTime();//开始时间转时间戳
            // console.log(timeStar)
            if (timeStar > 0) {
            timeReduce = nowTime - timeStar
                //计算出相差天数
            let days=Math.floor(timeReduce/(24*3600*1000));
            //计算出小时数
            let leave1=timeReduce%(24*3600*1000) ;   //计算天数后剩余的毫秒数
            let hours=Math.floor(leave1/(3600*1000));
            //计算相差分钟数
            let leave2=leave1%(3600*1000);        //计算小时数后剩余的毫秒数
            let minutes=Math.floor(leave2/(60*1000));
            //计算相差秒数
            let leave3=leave2%(60*1000);      //计算分钟数后剩余的毫秒数
            let seconds=Math.round(leave3/1000);
            hours = hours + days*24;//天数变成小时
            hours = String(hours<10?"0"+hours : hours);
            minutes = String(minutes<10?"0"+minutes : minutes);
            seconds = String(seconds<10?"0"+seconds : seconds);
            let t = hours+":"+minutes+":"+seconds
            this.TimeArr.push(t)
            
            }else{
                this.TimeArr.push("00:00:00")
            }
            // console.log(timeStar,nowTime)
        },
        multiple(){//点击多选按钮
            this.checkedAll = false
            this.checkIsShow = !this.checkIsShow
            this.leftBtn = !this.leftBtn
            this.checkerArr = []
            this.bothCheckBtn = []

        },
        bothChecked(v){            
            if (v) {                
                this.$refs.checkboxGroup.toggleAll(true);               
            }else{                
                this.$refs.checkboxGroup.toggleAll();                
            }
        },
        timingOpen(){//定时选择时间
            if (this.checkerArr.length) {
                this.checkerNameArr = []
                for (let i = 0; i < this.valveList.length; i++) {
                    for (let j = 0; j < this.checkerArr.length; j++) {
                        if (this.valveList[i].pc_id == this.checkerArr[j]) {
                            this.checkerNameArr.push(this.valveList[i].name)
                        }                        
                    }  
                }
                
                this.timingIsShow = true
                this.nowTime = ''
                this.durationValue = ''
                this.durationNum = ''

            }else{
                this.$toast('请勾选阀门');
            }
        },
        setDuration(value){
            this.durationValue = value
            if (value  == '自定义') {
                this.durationNum = ''
                this.durationShow = true
            }else{
                 this.durationNum = ''
                this.durationShow = false
            }
            this.durationPop = false
        },        
        setNewTime(){
            this.nowTime = this.timingTime
            this.timePop = false
        },
        setChangeTime(value){//时间选择器确定
            let endTimeArr = value.getValues();//["2019", "03", "22", "17", "28"]
            this.timingTime= `${endTimeArr[0]}-${endTimeArr[1]}-${endTimeArr[2]} ${endTimeArr[3]}:${endTimeArr[4]}`            

        },
        rListShow(){
            this.$emit('rListSon', 0);
        },
        changeFixed(clientHeight){//动态修改地图高度样式
            this.$nextTick(() => {
                this.$refs.pageMain.style.height = (clientHeight-134)+'px';
            })
        },
        valveOperate(valveInfo,i){
            let orderId = valveInfo.opened == 0 ? 1 : 0
            orderId == 1 ? console.log('开启阀门') : console.log('关闭阀门')
            let websockData = {
                magic      : 130,
                valveId    : valveInfo.pc_id,
                orderId    : orderId,
                pcUuid     : valveInfo.uuid + '',
                remoteUuid : this.$store.state.userUuid + '',
                token      : this.$store.state.token
            };            
            this.$store.state.websocket.ws.send(websockData)
            //开始倒计时
            this.countDown(i,orderId)
        },
        valveOperateOnMessage(){//阀门开关接收消息处理
            // window.clearInterval(setIn)
            let data = JSON.parse(this.$store.state.websocket.msg);
            
            //返回值只对当前控制器生效
            if(data.magic == 131 && this.uuid == data.pcUuid){
            console.log('当前页面处理开始处理websocket回应')
                if(data.state == 0){
                    if (data.orderId == 1) {
                        for (let i = 0; i < this.valveList.length; i++) {
                            if (this.valveList[i].pc_id ==data.valveId) {
                                window.clearInterval(this.setInArr[i])
                                this.valveList[i].opened = data.orderId
                                this.valveList[i].start_time = data.startTime                                               
                                this.valveList[i].status = 0
                                this.computeDate()                   
                            }                  
                        }                    
                        this.$toast.success('阀门开启成功')
                    }else{
                        // inmap.remove(lightLand)
                        for (let i = 0; i < this.valveList.length; i++) {
                            if (this.valveList[i].pc_id ==data.valveId) {
                                this.valveList[i].opened = 0
                                this.valveList[i].start_time = 0
                                window.clearInterval(this.setInArr[i])
                                this.valveList[i].status = 0
                                
                            }                             
                        }
                        
                        this.$toast.success('阀门关闭成功')
                    }
                }else{

                }
            }

        },
        nowOpen(){//多选阀门-立即开启
            console.log('多选阀门-立即开启')
            let websockData = {
                magic      : 222,
                Uuid       : this.uuid,
                valveId    : this.checkerArr,
                OpenTimeStamp  : 0,
                CloseTime  : 0,
                token      : this.$store.state.token
            };
            console.log(websockData)
            this.$store.state.websocket.ws.send(websockData)
            //倒计时
            for (let i = 0; i < this.checkerArr.length; i++) {
                for (let j = 0; j < this.valveList.length; j++) {
                    if (this.valveList[j].pc_id == this.checkerArr[i]) {            
                        this.countDown(j,1)
                    }         
                }  
            }
            
            this.checkerArr = []
        },
        timingStart(){//设置定时开启
            let time
            switch (this.durationValue) {
                case '不限时长':
                    time = 0
                    break;
                case '0.5小时':
                    time = 0.5
                    break;
                case '1小时':
                    time = 1
                    break;
                case '1.5小时':
                    time = 1.5
                    break;
                case '2小时':
                    time = 2
                    break;
                case '自定义':
                    time = this.durationNum
                    break;
            
                default:
                    break;
            }
            
            let stamp = parseInt(new Date(this.nowTime).getTime())/1000;

            
            let websockData = {
                magic      : 222,
                Uuid       : this.uuid,
                valveId    : this.checkerArr,
                OpenTimeStamp  : stamp,
                CloseTime  : time,
                token      : this.$store.state.token
            };
            console.log(websockData)
             let _that = this
            let second = 10
            this.$store.state.websocket.ws.send(websockData)
            timingCount = setInterval(() => {
                if (second == 0) {
                    _that.timingState = false
                     _that.$toast.fail('超时,请以实际情况为准')
                }else{
                    _that.timingState = true
                    second--                    
                }
            }, 1000);

            
        },
        multipleSelectionMessage(){//多选阀门返回信息
            let data = JSON.parse(this.$store.state.websocket.msg);            
            //返回值只对当前控制器生效
            if(data.magic == 223 && this.uuid == data.Uuid){
                console.log('多选阀门预约处理')
                if (data.state == 0) {
                    this.timingIsShow = false
                    this.timingState = false
                    this.checkerArr = []
                    this.$toast.success('阀门预约成功')
                }                
            } 
        },
        countDown(i,orderId){//倒计时
            let _that = this
            let second = 10    
            let setIn = setInterval(() => {
                if (second ==0) {
                this.valveList[i].status = 0                
                _that.$toast.fail('超时,请以实际情况为准')
                _that.getValveList()
                window.clearInterval(this.setInArr[i])
                }else{
                _that.valveList[i].status = 1
                second--
                _that.secondArr[i] = second
                
                }
            }, 1000);
            this.setInArr[i] = setIn
        },
    },

}
</script>

<style  scoped>
/* .valveBox{padding:5px} */
.valveBox img{vertical-align: middle}
.valveBox .leftImg{width:60px;float:left;margin-right:10px;}
.valveBox .rightIcon{float:right}
.valveBox .rightIcon li{margin:2px 0}
.valveBox .rightIcon li img{margin-right:5px;width:12px}
.valveBox .rightIcon li span{font-size:10px;}
.valveBox .timeBox{clear:both}
.valveBox .timeBox {margin-top:15px}
.valveBox .timeBox img{width:14px;margin-right:5px;vertical-align: middle;}
.valveBox .timeBox span{font-size:14px;line-height: 30px;vertical-align: middle;}
.valveTitle{line-height:32px;font-weight:bold}
.openBtn{width:90%;margin-top:10px;background-color:rgb(0, 129, 255);color:#fff}
.openBtn:active{background-color:rgb(81, 159, 235)!important;color:#fff!important}
.van-checkbox{justify-content:flex-end}

</style>